var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OptionsPanel',{ref:"optionspanel",attrs:{"tabs":_vm.tabs,"saving":_vm.saving,"initial-tab":_vm.initialTab,"initial-data":_vm.initialData,"more-label-index":7},on:{"settings-change":_vm.settingsChangeHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }